import React from 'react'
import PropTypes from 'prop-types'
import { ItemCloudinaryViewer } from './CloudinaryViewer'
import { NativeViewerContainer } from './NativeViewer'
import { BoxViewer } from './BoxViewer'

const VIEWER_TYPE_COMPONENTS = {
  native: NativeViewerContainer,
  cloudinary: ItemCloudinaryViewer,
  box: BoxViewer
}

function File(props) {
  const SpecificViewer = VIEWER_TYPE_COMPONENTS[props.item.file_viewer_type]

  return(
    <SpecificViewer
      item={props.item}
      previewMetadata={props.previewMetadata} />
  )
}

File.propTypes = {
  item: PropTypes.object.isRequired,
  previewMetadata: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.object.isRequired
  ])
}

export default File
